<template>
  <v-card flat rounded class="my-2">
    <v-card-text>
      <h2 class="secondary--text mb-4">Bank Details</h2>
      <v-alert type="info" outlined dense class="mb-4">
        Please ensure bank details are entered correctly. These will be used for payments to the contractor.
      </v-alert>
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              :value="localValue.accountName"
              @input="updateField('accountName', $event)"
              label="Account Name *"
              outlined
              dense
              :rules="[v => !!v || 'Account name is required']"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="localValue.accountNumber"
              @input="updateField('accountNumber', $event)"
              label="Account Number *"
              outlined
              dense
              :rules="accountNumberRules"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              :value="localValue.sortCode"
              @input="handleSortCodeInput"
              label="Sort Code *"
              outlined
              dense
              placeholder="00-00-00"
              :rules="sortCodeRules"
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              :value="localValue.legacyBacsReference"
              @input="updateField('legacyBacsReference', $event)"
              label="BACS Reference (Optional)"
              outlined
              dense
              hint="Reference that will appear on bank statements"
              persistent-hint
              :rules="bacsReferenceRules"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn text @click="$emit('back')">
        Back
      </v-btn>
      <v-spacer />
      <v-btn
        color="primary"
        :disabled="!canProceed || loading"
        :loading="loading"
        @click="handleNext"
      >
        Next
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ContractorBankDetailsStep",
  props: {
    value: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      valid: false,
      accountNumberRules: [
        v => !!v || "Account number is required",
        v => /^\d{8}$/.test(v.replace(/\s/g, "")) || "Account number must be 8 digits"
      ],
      sortCodeRules: [
        v => !!v || "Sort code is required",
        v => /^\d{2}-?\d{2}-?\d{2}$/.test(v) || "Sort code must be in format 00-00-00"
      ],
      bacsReferenceRules: [
        v => !v || v.length <= 18 || "BACS reference must be 18 characters or less"
      ]
    };
  },
  computed: {
    canProceed() {
      return this.valid;
    },
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    updateField(field, value) {
      const updatedValue = { ...this.localValue, [field]: value };
      this.$emit("input", updatedValue);
    },
    handleNext() {
      if (this.$refs.form.validate()) {
        this.$emit("next");
      }
    },
    handleSortCodeInput(value) {
      let formattedValue = value.replace(/[^\d]/g, "");
      if (formattedValue.length >= 4) {
        formattedValue = formattedValue.slice(0, 2) + "-" + formattedValue.slice(2, 4) + "-" + formattedValue.slice(4, 6);
      } else if (formattedValue.length >= 2) {
        formattedValue = formattedValue.slice(0, 2) + "-" + formattedValue.slice(2);
      }
      this.updateField('sortCode', formattedValue);
    }
  }
};
</script>